import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// 获取登录信息
const getToken = () => localStorage.getItem('base_token') || localStorage.getItem('cms_token') || ''
const getPartnerId = () => localStorage.getItem('cms_institution_id') || localStorage.getItem('boxiaotu_institution_id') || localStorage.getItem('cms_user_id') || localStorage.getItem('base_id') || ''
const getPartnerType = () => {
  const role = localStorage.getItem('cms_role')
  if (role === 'agent') return 'agent'
  if (role === 'partner') return 'partner'
  return localStorage.getItem('base_id') ? 'base' : 'institution'
}
const getPartnerInfo = () => {
  const cmsUser = localStorage.getItem('cms_user')
  const baseInfo = localStorage.getItem('base_info')
  const orgInfo = localStorage.getItem('institution_info')
  return cmsUser ? JSON.parse(cmsUser) : (baseInfo ? JSON.parse(baseInfo) : (orgInfo ? JSON.parse(orgInfo) : null))
}

export default function PartnerStore({ initialTab }) {
  const [activeTab, setActiveTab] = useState(initialTab || 'dashboard')
  const [partnerInfo, setPartnerInfo] = useState(getPartnerInfo())
  const [partnerType, setPartnerType] = useState(getPartnerType())

  // 数据状态
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalRevenue: 0,
    totalMembers: 0,
    todayAppointments: 0,
    pendingActivities: 0,
    activeCourses: 0
  })

  // 订单数据
  const [orders, setOrders] = useState([])

  // 活动数据
  const [activities, setActivities] = useState([])
  const [showActivityModal, setShowActivityModal] = useState(false)
  const [editActivity, setEditActivity] = useState(null)
  const [activityForm, setActivityForm] = useState({
    title: '', type: '研学', activityDate: '', location: '', price: '',
    maxParticipants: '', ageRange: '', description: ''
  })

  // 预约数据
  const [appointments, setAppointments] = useState([])
  const [showAppointmentModal, setShowAppointmentModal] = useState(false)
  const [appointmentForm, setAppointmentForm] = useState({
    customerName: '', customerPhone: '', appointmentDate: '', appointmentTime: '', serviceType: '体验'
  })

  // 订单数据
  const [showOrderModal, setShowOrderModal] = useState(false)
  const [orderForm, setOrderForm] = useState({
    customerName: '', customerPhone: '', productName: '', amount: ''
  })

  // 会员数据
  const [members, setMembers] = useState([])
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [memberForm, setMemberForm] = useState({
    name: '', phone: '', memberLevel: '普通会员'
  })
  const [showRechargeModal, setShowRechargeModal] = useState(false)
  const [rechargeMember, setRechargeMember] = useState(null)
  const [rechargeAmount, setRechargeAmount] = useState('')

  // 核销数据
  const [verifications, setVerifications] = useState([])
  const [verifyCode, setVerifyCode] = useState('')

  // 动画配额数据
  const [creditBalance, setCreditBalance] = useState(null)
  const [creditAssignments, setCreditAssignments] = useState([])
  const [showBuyCreditModal, setShowBuyCreditModal] = useState(false)
  const [buyForm, setBuyForm] = useState({ productName: 'AI动画10次包', quantity: 1 })

  // 推广分享弹窗
  const [shareModal, setShareModal] = useState({ open: false, product: null, loading: false, image: "" })
  const [shareCopyMsg, setShareCopyMsg] = useState("")
  const [showAssignModal, setShowAssignModal] = useState(false)
  const [assignForm, setAssignForm] = useState({ phone: '', childName: '', credits: '1' })

  // 课程配额数据
  const [courseQuotas, setCourseQuotas] = useState([])
  const [courseAssignments, setCourseAssignments] = useState([])
  const [showBuyCourseModal, setShowBuyCourseModal] = useState(false)
  const [showAssignCourseModal, setShowAssignCourseModal] = useState(false)
  const [buyCourseForm, setBuyCourseForm] = useState({ productName: '', productId: '', quantity: 1 })
  const [assignCourseForm, setAssignCourseForm] = useState({ productId: '', childName: '', childPhone: '' })

  const token = getToken()
  const partnerId = getPartnerId()

  useEffect(() => {
    loadDashboard()
  }, [])

  // API请求封装
  const apiGet = async (path) => {
    const res = await fetch(`${API}${path}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return res.json()
  }

  const apiPost = async (path, data) => {
    const res = await fetch(`${API}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    })
    return res.json()
  }

  const apiPut = async (path, data) => {
    const res = await fetch(`${API}${path}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(data)
    })
    return res.json()
  }

  const apiDelete = async (path) => {
    const res = await fetch(`${API}${path}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    })
    return res.json()
  }


  const loadDashboard = async () => {
    try {
      const res = await apiGet(`/partner-store/stats?partnerId=${partnerId}&type=${partnerType}`)
      if (res.success) {
        setStats(res.data)
      }

      const ordersRes = await apiGet(`/partner-store/orders?partnerId=${partnerId}&type=${partnerType}&limit=10`)
      if (ordersRes.success) {
        setOrders(ordersRes.data || [])
      }
    } catch (e) {
      console.error('加载数据失败', e)
    }
  }

  const loadActivities = async () => {
    try {
      const res = await apiGet(`/base-activities/${partnerId}`)
      if (res.success) {
        setActivities(res.data || [])
      }
    } catch (e) {
      console.error('加载活动失败', e)
    }
  }

  const loadAppointments = async () => {
    try {
      const res = await apiGet(`/partner-store/appointments?partnerId=${partnerId}`)
      if (res.success) {
        setAppointments(res.data || [])
      }
    } catch (e) {
      console.error('加载预约失败', e)
    }
  }

  const loadMembers = async () => {
    try {
      const res = await apiGet(`/partner-store/members?partnerId=${partnerId}`)
      if (res.success) {
        setMembers(res.data || [])
      }
    } catch (e) {
      console.error('加载会员失败', e)
    }
  }

  const loadVerifications = async () => {
    try {
      const res = await apiGet(`/partner-store/verifications?partnerId=${partnerId}`)
      if (res.success) {
        setVerifications(res.data || [])
      }
    } catch (e) {
      console.error('加载核销记录失败', e)
    }
  }

  // 加载动画配额数据
  const loadCreditData = async () => {
    try {
      const instId = getPartnerId()
      const [balRes, assignRes] = await Promise.all([
        apiGet(`/courses/quota/credits-balance?institutionId=${instId}`),
        apiGet(`/courses/quota/credit-assignments?institutionId=${instId}`)
      ])
      if (balRes.success) setCreditBalance(balRes.data)
      if (assignRes.success) setCreditAssignments(assignRes.data || [])
    } catch (e) {
      console.error('加载动画配额数据失败', e)
    }
  }

  // 加载课程配额数据
  const loadCourseQuotaData = async () => {
    try {
      const instId = getPartnerId()
      const [balRes, assignRes] = await Promise.all([
        apiGet(`/courses/quota/balance?institutionId=${instId}`),
        apiGet(`/courses/quota/assignments?institutionId=${instId}`)
      ])
      if (balRes.success) setCourseQuotas(balRes.data || [])
      if (assignRes.success) setCourseAssignments(assignRes.data || [])
    } catch (e) {
      console.error('加载课程配额数据失败', e)
    }
  }

  // 切换Tab时加载数据
  useEffect(() => {
    if (activeTab === 'activities') loadActivities()
    if (activeTab === 'audit') loadActivities()
    if (activeTab === 'appointments') loadAppointments()
    if (activeTab === 'members') loadMembers()
    if (activeTab === 'verification') loadVerifications()
    if (activeTab === 'credits') loadCreditData()
    if (activeTab === 'courseQuota') loadCourseQuotaData()
    if (activeTab === 'inst_activities') loadInstitutionActivities()
    if (activeTab === 'brand') loadBrandConfig()
    if (activeTab === 'miniapp') loadProductConfig()
    if (activeTab === 'activity_shelf') loadActivityShelf()
    if (activeTab === 'settlement') loadSettlementData()
    if (activeTab === 'salespersons') loadSalespersons()
  }, [activeTab])

  const handleLogout = () => {
    localStorage.removeItem('base_token')
    localStorage.removeItem('base_id')
    localStorage.removeItem('base_info')
    localStorage.removeItem('institution_token')
    localStorage.removeItem('institution_id')
    localStorage.removeItem('institution_info')
    localStorage.removeItem('cms_token')
    localStorage.removeItem('cms_user')
    localStorage.removeItem('cms_role')
    localStorage.removeItem('cms_user_id')
    window.location.reload()
  }

  // 创建/更新活动
  const handleSaveActivity = async () => {
    if (!activityForm.title) { alert('请填写活动名称'); return }

    try {
      const res = await apiPost('/base-activities', {
        baseId: partnerId,
        ...activityForm
      })

      if (res.success) {
        alert(res.data?.message || '保存成功')
        setShowActivityModal(false)
        loadActivities()
      } else {
        alert(res.error || '保存失败')
      }
    } catch (e) {
      alert('保存失败')
    }
  }

  const openEditActivity = (a) => {
    setEditActivity(a)
    setActivityForm({
      title: a.title,
      type: a.type,
      activityDate: a.activity_date || a.activityDate,
      location: a.location,
      price: a.price,
      maxParticipants: a.max_participants || a.maxParticipants,
      ageRange: a.ageRange,
      description: a.description
    })
    setShowActivityModal(true)
  }

  const publishActivity = async (id) => {
    try {
      const res = await apiPost(`/partner-store/activities/${id}/publish`, {})
      if (res.success) {
        alert('发布成功')
        loadActivities()
      } else {
        alert(res.error || '发布失败')
      }
    } catch (e) {
      alert('发布失败')
    }
  }

  // 删除活动
  const handleDeleteActivity = async (id) => {
    if (!confirm('确认删除此活动？此操作不可恢复！')) return
    try {
      const res = await apiDelete(`/base-activities/${id}`)
      if (res.success) {
        alert('删除成功')
        loadActivities()
      } else {
        alert(res.error || '删除失败')
      }
    } catch (e) {
      alert('删除失败')
    }
  }

  // 核销
  const handleVerify = async () => {
    if (!verifyCode.trim()) { alert('请输入核销码'); return }

    try {
      const res = await apiPost('/partner-store/verify', {
        code: verifyCode,
        partnerId
      })

      if (res.success) {
        alert(`核销成功!\n验证码:${res.data.code}`)
        setVerifyCode('')
        loadVerifications()
      } else {
        alert(res.error || '核销失败')
      }
    } catch (e) {
      alert('核销失败')
    }
  }

  // ========== 新增功能处理 ==========

  // 导出订单
  const handleExportOrders = async () => {
    try {
      const res = await apiGet(`/partner-store/orders/export?partnerId=${partnerId}`)
      if (res.success && res.data.length > 0) {
        const csv = '订单号,客户,金额,状态,时间\n' +
          (res.data || []).map(o => `${o.orderNo},${o.customerName},${o.amount},${o.status},${o.createdAt}`).join('\n')
        const blob = new Blob([csv], { type: 'text/csv' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `订单_${new Date().toISOString().slice(0,10)}.csv`
        a.click()
        URL.revokeObjectURL(url)
        alert('导出成功!')
      } else {
        alert('暂无订单可导出')
      }
    } catch (e) {
      alert('导出失败')
    }
  }

  // 创建订单
  const handleCreateOrder = async () => {
    if (!orderForm.customerName || !orderForm.amount) {
      alert('请填写客户姓名和金额'); return
    }
    try {
      const res = await apiPost('/partner-store/orders', {
        partnerId,
        order: orderForm
      })
      if (res.success) {
        alert('订单创建成功!订单号:' + res.data.orderNo)
        setShowOrderModal(false)
        setOrderForm({ customerName: '', customerPhone: '', productName: '', amount: '' })
        loadDashboard()
      } else {
        alert(res.error || '创建失败')
      }
    } catch (e) {
      alert('创建失败')
    }
  }

  // 创建预约
  const handleCreateAppointment = async () => {
    if (!appointmentForm.customerName || !appointmentForm.appointmentDate) {
      alert('请填写客户姓名和预约日期'); return
    }
    try {
      const res = await apiPost('/partner-store/appointments', {
        partnerId,
        appointment: appointmentForm
      })
      if (res.success) {
        alert('预约创建成功!')
        setShowAppointmentModal(false)
        setAppointmentForm({ customerName: '', customerPhone: '', appointmentDate: '', appointmentTime: '', serviceType: '体验' })
        loadAppointments()
      } else {
        alert(res.error || '创建失败')
      }
    } catch (e) {
      alert('创建失败')
    }
  }

  // 确认预约
  const handleConfirmAppointment = async (id) => {
    if (!confirm('确认此预约?')) return
    try {
      const res = await apiPost(`/partner-store/appointments/${id}/confirm`, {})
      if (res.success) {
        alert('预约已确认!')
        loadAppointments()
      } else {
        alert(res.error || '确认失败')
      }
    } catch (e) {
      alert('确认失败')
    }
  }

  // 创建会员
  const handleCreateMember = async () => {
    if (!memberForm.name || !memberForm.phone) {
      alert('请填写姓名和电话'); return
    }
    try {
      const res = await apiPost('/partner-store/members', {
        partnerId,
        member: memberForm
      })
      if (res.success) {
        alert('会员创建成功!')
        setShowMemberModal(false)
        setMemberForm({ name: '', phone: '', memberLevel: '普通会员' })
        loadMembers()
      } else {
        alert(res.error || '创建失败')
      }
    } catch (e) {
      alert('创建失败')
    }
  }

  // 会员充值
  const handleRecharge = async () => {
    if (!rechargeAmount || rechargeAmount <= 0) {
      alert('请输入正确的充值金额'); return
    }
    try {
      const res = await apiPost(`/partner-store/members/${rechargeMember.id}/recharge`, {
        amount: parseFloat(rechargeAmount)
      })
      if (res.success) {
        alert('充值成功!充值金额:¥' + rechargeAmount)
        setShowRechargeModal(false)
        setRechargeAmount('')
        setRechargeMember(null)
        loadMembers()
      } else {
        alert(res.error || '充值失败')
      }
    } catch (e) {
      alert('充值失败')
    }
  }

  // Tab配置
  const tabs = [
    { key: 'dashboard', label: '工作台', icon: '📊' },
    { key: 'activities', label: '活动管理', icon: '🎪' },
    { key: 'audit', label: '待审核', icon: '⏳' },
    { key: 'appointments', label: '预约排课', icon: '📅' },
    { key: 'orders', label: '订单管理', icon: '💰' },
    { key: 'members', label: '会员管理', icon: '👥' },
    { key: 'verification', label: '核销管理', icon: '✅' },
    { key: 'credits', label: '动画配额', icon: '🎬' },
    { key: 'courseQuota', label: '课程配额', icon: '📚' },
    { key: 'inst_activities', label: '机构活动管理', icon: '📋' },
    { key: 'brand', label: '品牌配置', icon: '🎨' },
    { key: 'miniapp', label: '商品上架', icon: '📦' },
    { key: 'activity_shelf', label: '活动上架', icon: '🏕️' },
    { key: 'settlement', label: '结算管理', icon: '💳' },
    { key: 'salespersons', label: '业务员管理', icon: '👤' },
  ]

  const statusMap = {
    draft: { text: '草稿', color: '#999', bg: '#f5f5f5' },
    pending: { text: '待审核', color: '#faad14', bg: '#fffbe6' },
    published: { text: '已上架', color: '#52c41a', bg: '#f6ffed' },
    rejected: { text: '已拒绝', color: '#ff4d4f', bg: '#fff1f0' }
  }

  // 渲染工作台
  const renderDashboard = () => (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 20, marginBottom: 16 }}>欢迎回来,{partnerInfo?.name || '合作伙伴'}!</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          <StatCard icon="💰" label="总订单" value={stats.totalOrders} color="#1890ff" />
          <StatCard icon="📈" label="总收入" value={`¥${stats.totalRevenue}`} color="#52c41a" />
          <StatCard icon="👥" label="会员数" value={stats.totalMembers} color="#fa8c16" />
          <StatCard icon="📅" label="今日预约" value={stats.todayAppointments} color="#722ed1" />
          <StatCard icon="🎪" label="进行中活动" value={stats.pendingActivities} color="#eb2f96" />
          <StatCard icon="📚" label="课程数" value={stats.activeCourses} color="#13c2c2" />
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        <h3 style={{ marginBottom: 16 }}>📋 最新订单</h3>
        {orders.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>暂无订单数据</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>订单号</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>客户</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>金额</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>状态</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>时间</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{order.orderNo}</td>
                  <td style={{ padding: '12px 8px' }}>{order.customerName}</td>
                  <td style={{ padding: '12px 8px', color: '#52c41a' }}>¥{order.amount}</td>
                  <td style={{ padding: '12px 8px' }}>
                    <span style={{
                      padding: '2px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      background: order.status === 'paid' ? '#f6ffed' : '#fffbe6',
                      color: order.status === 'paid' ? '#52c41a' : '#faad14'
                    }}>
                      {order.status === 'paid' ? '已支付' : '待支付'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 8px', color: '#999', fontSize: 13 }}>{order.createdAt?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染活动管理
  const renderActivities = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <h2>🎪 活动管理</h2>
        <button
          onClick={() => { setEditActivity(null); setActivityForm({ title: '', type: '研学', activityDate: '', location: '', price: '', maxParticipants: '', ageRange: '', description: '' }); setShowActivityModal(true); }}
          style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
        >
          + 发布活动
        </button>
      </div>

      {showActivityModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 500, maxHeight: '80vh', overflow: 'auto' }}>
            <h3 style={{ margin: '0 0 20px' }}>{editActivity ? '编辑活动' : '发布活动'}</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>活动名称 *</label>
              <input value={activityForm.title} onChange={e => setActivityForm({...activityForm, title: e.target.value})} placeholder="例如:小小医生职业体验" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动类型</label>
                <select value={activityForm.type} onChange={e => setActivityForm({...activityForm, type: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                  <option value="研学">研学</option>
                  <option value="课程">课程</option>
                  <option value="活动">活动</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动日期</label>
                <input type="date" value={activityForm.activityDate} onChange={e => setActivityForm({...activityForm, activityDate: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>活动地点</label>
              <input value={activityForm.location} onChange={e => setActivityForm({...activityForm, location: e.target.value})} placeholder="活动地点" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>价格(元)</label>
                <input type="number" value={activityForm.price} onChange={e => setActivityForm({...activityForm, price: e.target.value})} placeholder="0" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>名额</label>
                <input type="number" value={activityForm.maxParticipants} onChange={e => setActivityForm({...activityForm, maxParticipants: e.target.value})} placeholder="30" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>年龄</label>
                <input value={activityForm.ageRange} onChange={e => setActivityForm({...activityForm, ageRange: e.target.value})} placeholder="6-12岁" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>活动介绍</label>
              <textarea value={activityForm.description} onChange={e => setActivityForm({...activityForm, description: e.target.value})} rows={3} placeholder="活动介绍..." style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowActivityModal(false)} style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleSaveActivity} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6 }}>保存</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        {activities.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎪</div>
            <p>暂无活动,点击上方按钮发布活动</p>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>活动名称</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>类型</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>日期</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>价格</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>报名</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>状态</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {activities.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 500 }}>{a.title}</td>
                  <td style={{ padding: '12px 8px' }}>{a.type}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{a.activity_date || a.activityDate}</td>
                  <td style={{ padding: '12px 8px', color: '#52c41a' }}>{a.price > 0 ? `¥${a.price}` : '免费'}</td>
                  <td style={{ padding: '12px 8px' }}>{(a.current_participants || a.currentParticipants || 0)}/{(a.max_participants || a.maxParticipants || 30)}</td>
                  <td style={{ padding: '12px 8px' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: statusMap[a.status]?.bg, color: statusMap[a.status]?.color }}>
                      {statusMap[a.status]?.text}
                    </span>
                  </td>
                  <td style={{ padding: '12px 8px' }}>
                                        <button onClick={() => openEditActivity(a)} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>编辑</button>
                    <button onClick={() => handleDeleteActivity(a.id)} style={{ padding: '4px 12px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染预约排课
  const renderAppointments = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>📅 预约排课</h2>
        <button 
          onClick={() => { setShowAppointmentModal(true) }}
          style={{ padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
        >
          + 添加预约
        </button>
      </div>
      
      {showAppointmentModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 450 }}>
            <h3 style={{ margin: '0 0 20px' }}>添加预约</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>客户姓名 *</label>
              <input value={appointmentForm.customerName} onChange={e => setAppointmentForm({...appointmentForm, customerName: e.target.value})} placeholder="请输入客户姓名" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>联系电话</label>
              <input value={appointmentForm.customerPhone} onChange={e => setAppointmentForm({...appointmentForm, customerPhone: e.target.value})} placeholder="请输入联系电话" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>预约日期 *</label>
                <input type="date" value={appointmentForm.appointmentDate} onChange={e => setAppointmentForm({...appointmentForm, appointmentDate: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>时间段</label>
                <input value={appointmentForm.appointmentTime} onChange={e => setAppointmentForm({...appointmentForm, appointmentTime: e.target.value})} placeholder="如：10:00-12:00" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>服务类型</label>
              <select value={appointmentForm.serviceType} onChange={e => setAppointmentForm({...appointmentForm, serviceType: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                <option value="体验">体验</option>
                <option value="课程">课程</option>
                <option value="托管">托管</option>
                <option value="其他">其他</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowAppointmentModal(false)} style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleCreateAppointment} style={{ padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6 }}>创建预约</button>
            </div>
          </div>
        </div>
      )}
      
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        {appointments.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
            <p>暂无预约记录，点击上方按钮添加</p>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>客户</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>电话</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>日期</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>时间段</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>服务类型</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>状态</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {appointments.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px' }}>{a.customerName}</td>
                  <td style={{ padding: '12px 8px' }}>{a.customerPhone}</td>
                  <td style={{ padding: '12px 8px' }}>{a.appointmentDate}</td>
                  <td style={{ padding: '12px 8px' }}>{a.appointmentTime}</td>
                  <td style={{ padding: '12px 8px' }}>{a.serviceType}</td>
                  <td style={{ padding: '12px 8px' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: a.status === 'confirmed' ? '#f6ffed' : '#fffbe6', color: a.status === 'confirmed' ? '#52c41a' : '#faad14' }}>
                      {a.status === 'confirmed' ? '已确认' : '待确认'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 8px' }}>
                    {a.status !== 'confirmed' && (
                      <button onClick={() => handleConfirmAppointment(a.id)} style={{ padding: '4px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>确认</button>
                    )}
                    <button onClick={() => alert('编辑预约功能开发中')} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>编辑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染订单管理
  const renderOrders = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>💰 订单管理</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button 
            onClick={handleExportOrders}
            style={{ padding: '10px 20px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            📥 导出
          </button>
          <button 
            onClick={() => setShowOrderModal(true)}
            style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            + 新建订单
          </button>
        </div>
      </div>
      
      {showOrderModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 450 }}>
            <h3 style={{ margin: '0 0 20px' }}>新建订单</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>客户姓名 *</label>
              <input value={orderForm.customerName} onChange={e => setOrderForm({...orderForm, customerName: e.target.value})} placeholder="请输入客户姓名" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>联系电话</label>
              <input value={orderForm.customerPhone} onChange={e => setOrderForm({...orderForm, customerPhone: e.target.value})} placeholder="请输入联系电话" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>商品名称</label>
              <input value={orderForm.productName} onChange={e => setOrderForm({...orderForm, productName: e.target.value})} placeholder="请输入商品名称" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>金额(元) *</label>
              <input type="number" value={orderForm.amount} onChange={e => setOrderForm({...orderForm, amount: e.target.value})} placeholder="0" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowOrderModal(false)} style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleCreateOrder} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6 }}>创建订单</button>
            </div>
          </div>
        </div>
      )}
      
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        {orders.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>💰</div>
            <p>暂无订单</p>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: 12, textAlign: 'left' }}>订单号</th>
                <th style={{ padding: 12, textAlign: 'left' }}>客户</th>
                <th style={{ padding: 12, textAlign: 'left' }}>金额</th>
                <th style={{ padding: 12, textAlign: 'left' }}>状态</th>
                <th style={{ padding: 12, textAlign: 'left' }}>时间</th>
                <th style={{ padding: 12, textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 12, fontSize: 13 }}>{order.orderNo}</td>
                  <td style={{ padding: 12 }}>{order.customerName}</td>
                  <td style={{ padding: 12, color: '#52c41a' }}>¥{order.amount}</td>
                  <td style={{ padding: 12 }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: order.status === 'paid' ? '#f6ffed' : '#fffbe6', color: order.status === 'paid' ? '#52c41a' : '#faad14' }}>
                      {order.status === 'paid' ? '已支付' : '待支付'}
                    </span>
                  </td>
                  <td style={{ padding: 12, color: '#999', fontSize: 13 }}>{order.createdAt?.slice(0, 10)}</td>
                  <td style={{ padding: 12 }}>
                    <button onClick={() => alert('查看详情功能开发中')} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>详情</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染会员管理
  const renderMembers = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>👥 会员管理</h2>
        <button
          onClick={() => setShowMemberModal(true)}
          style={{ padding: '10px 20px', background: '#eb2f96', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
        >
          + 添加会员
        </button>
      </div>
      
      {/* 添加会员弹窗 */}
      {showMemberModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 450 }}>
            <h3 style={{ margin: '0 0 20px' }}>添加会员</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>姓名 *</label>
              <input value={memberForm.name} onChange={e => setMemberForm({...memberForm, name: e.target.value})} placeholder="请输入会员姓名" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>电话 *</label>
              <input value={memberForm.phone} onChange={e => setMemberForm({...memberForm, phone: e.target.value})} placeholder="请输入联系电话" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>会员等级</label>
              <select value={memberForm.memberLevel} onChange={e => setMemberForm({...memberForm, memberLevel: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                <option value="普通会员">普通会员</option>
                <option value="银卡会员">银卡会员</option>
                <option value="金卡会员">金卡会员</option>
                <option value="钻石会员">钻石会员</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowMemberModal(false)} style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleCreateMember} style={{ padding: '10px 20px', background: '#eb2f96', color: '#fff', border: 'none', borderRadius: 6 }}>创建会员</button>
            </div>
          </div>
        </div>
      )}
      
      {/* 充值弹窗 */}
      {showRechargeModal && rechargeMember && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 400 }}>
            <h3 style={{ margin: '0 0 20px' }}>会员充值 - {rechargeMember.name}</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>充值金额(元)</label>
              <input type="number" value={rechargeAmount} onChange={e => setRechargeAmount(e.target.value)} placeholder="请输入充值金额" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16, color: '#666', fontSize: 13 }}>
              当前余额：¥{rechargeMember.balance || 0} | 当前积分：{rechargeMember.points || 0}
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => { setShowRechargeModal(false); setRechargeAmount(''); setRechargeMember(null); }} style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleRecharge} style={{ padding: '10px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6 }}>确认充值</button>
            </div>
          </div>
        </div>
      )}
      
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        {members.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>👥</div>
            <p>暂无会员，点击上方按钮添加</p>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: 12, textAlign: 'left' }}>姓名</th>
                <th style={{ padding: 12, textAlign: 'left' }}>电话</th>
                <th style={{ padding: 12, textAlign: 'left' }}>等级</th>
                <th style={{ padding: 12, textAlign: 'left' }}>余额</th>
                <th style={{ padding: 12, textAlign: 'left' }}>积分</th>
                <th style={{ padding: 12, textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {members.map(m => (
                <tr key={m.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 12 }}>{m.name}</td>
                  <td style={{ padding: 12 }}>{m.phone}</td>
                  <td style={{ padding: 12 }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#fffbe6', color: '#faad14' }}>
                      {m.memberLevel || '普通会员'}
                    </span>
                  </td>
                  <td style={{ padding: 12, color: '#52c41a' }}>¥{m.balance || 0}</td>
                  <td style={{ padding: 12, color: '#1890ff' }}>{m.points || 0}</td>
                  <td style={{ padding: 12 }}>
                    <button onClick={() => alert('编辑会员功能开发中')} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>编辑</button>
                    <button onClick={() => { setRechargeMember(m); setShowRechargeModal(true); }} style={{ padding: '4px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>充值</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染核销管理
  const renderVerification = () => (
    <div>
      <h2 style={{ marginBottom: 20 }}>✅ 核销管理</h2>
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>📱</div>
          <p style={{ marginBottom: 16 }}>扫码核销</p>
          <input
            type="text"
            value={verifyCode}
            onChange={e => setVerifyCode(e.target.value)}
            placeholder="输入核销码"
            style={{ padding: '12px 16px', width: 300, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14 }}
          />
          <button
            onClick={handleVerify}
            style={{ display: 'block', margin: '16px auto 0', padding: '10px 32px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            确认核销
          </button>
        </div>

        <div style={{ marginTop: 24 }}>
          <h4 style={{ marginBottom: 12 }}>核销记录</h4>
          {verifications.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#999', padding: 20 }}>暂无核销记录</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <th style={{ padding: '12px 8px', textAlign: 'left' }}>核销码</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left' }}>商品</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left' }}>核销时间</th>
                </tr>
              </thead>
              <tbody>
                {verifications.map(v => (
                  <tr key={v.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px 8px', fontFamily: 'monospace' }}>{v.code}</td>
                    <td style={{ padding: '12px 8px' }}>{v.productName}</td>
                    <td style={{ padding: '12px 8px', color: '#999', fontSize: 13 }}>{v.usedAt?.slice(0, 16)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )

  const COURSE_PRODUCTS = [
    { id: 1, name: '七彩故事工坊', icon: '🌈', unitPrice: 149, note: '含线上权限' },
    { id: 2, name: '绘本剧场', icon: '🎭', unitPrice: 49 },
    { id: 3, name: '职业探索', icon: '🎬', unitPrice: 49 },
    { id: 4, name: '童话创演', icon: '🎪', unitPrice: 49 },
  ]

  // 采购课程配额
  const handleBuyCourseQuota = async () => {
    if (!buyCourseForm.productName) { alert('请选择课程'); return }
    if (!buyCourseForm.quantity || buyCourseForm.quantity < 1) { alert('请输入正确的数量'); return }

    try {
      const product = COURSE_PRODUCTS.find(p => p.id === parseInt(buyCourseForm.productId))
      const res = await apiPost('/courses/quota/purchase', {
        institutionId: getPartnerId(),
        productId: parseInt(buyCourseForm.productId),
        productName: product ? product.name : buyCourseForm.productName,
        quantity: buyCourseForm.quantity
      })
      if (res.success) {
        alert(`采购成功! 课程: ${res.data.productName}, 数量: ${res.data.quantity}`)
        setShowBuyCourseModal(false)
        loadCourseQuotaData()
      } else {
        alert(res.error || '采购失败')
      }
    } catch (e) {
      alert('采购失败: ' + e.message)
    }
  }

  // 分配课程给学员
  const handleAssignCourse = async () => {
    if (!assignCourseForm.productId) { alert('请选择课程'); return }
    if (!assignCourseForm.childPhone) { alert('请输入孩子ID或手机号'); return }

    try {
      const isPhone = /^1\d{10}$/.test(assignCourseForm.childPhone)
      const body = {
        institutionId: getPartnerId(),
        productId: parseInt(assignCourseForm.productId),
        childId: isPhone ? assignCourseForm.childPhone : assignCourseForm.childPhone,
        childName: assignCourseForm.childName || '',
        phone: isPhone ? assignCourseForm.childPhone : ''
      }
      const res = await apiPost('/courses/quota/assign', body)
      if (res.success) {
        alert(`分配成功! 已分配 ${res.data.productName} 给 ${assignCourseForm.childName || assignCourseForm.childPhone}`)
        setShowAssignCourseModal(false)
        loadCourseQuotaData()
      } else {
        alert(res.error || '分配失败')
      }
    } catch (e) {
      alert('分配失败: ' + e.message)
    }
  }

  // 渲染课程配额
  // 商品上架管理
  const [allProducts, setAllProducts] = useState([])      // 全量商品列表
  const [shelfProducts, setShelfProducts] = useState([])    // 已上架商品列表
  const [enabledIds, setEnabledIds] = useState(new Set())   // 勾选的商品ID集合

  const [prodLoading, setProdLoading] = useState(true)
  const [prodSaving, setProdSaving] = useState(false)
  const [prodMsg, setProdMsg] = useState('')

  const loadProductConfig = async () => {
    setProdLoading(true)
    try {
      const token = getToken()
      const id = getPartnerId()
      // 并行加载全量商品和已上架商品
      const [allRes, shelfRes] = await Promise.all([
        fetch(API + '/products', { headers: { 'Authorization': 'Bearer ' + token } }).then(r => r.json()),
        fetch(API + '/institutions/' + id + '/products', { headers: { 'Authorization': 'Bearer ' + token } }).then(r => r.json())
      ])
      if (allRes.success) {
        // 只显示 active 的商品
        const active = (allRes.data || []).filter(p => p.status === 'active')
        setAllProducts(active)
      }
      if (shelfRes.success) {
        const shelf = shelfRes.data || []
        setShelfProducts(shelf)
        setEnabledIds(new Set(shelf.filter(s => s.enabled).map(s => s.product_id)))

      }
    } catch (e) {
      console.error('加载商品数据失败', e)
    } finally {
      setProdLoading(false)
    }
  }

  const saveProductConfig = async () => {
    setProdSaving(true)
    setProdMsg('')
    try {
      const token = getToken()
      const id = getPartnerId()
      let changed = 0
      // 遍历所有商品，上架勾选的、下架取消的
      for (const p of allProducts) {
        const isEnabled = enabledIds.has(p.id)
        const existing = shelfProducts.find(s => s.product_id === p.id)
        if ((existing && existing.enabled !== isEnabled) || (!existing && isEnabled)) {
          await fetch(API + '/institutions/' + id + '/products', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ product_id: p.id, enabled: isEnabled })
          })
          changed++
        }
      }
      setProdMsg(changed > 0 ? ('✅ 已更新 ' + changed + ' 项商品') : '✅ 无变更')
      setTimeout(() => setProdMsg(''), 3000)
    } catch (e) {
      setProdMsg('❌ 保存异常: ' + e.message)
    } finally {
      setProdSaving(false)
    }
  }

  const toggleProduct = (id) => {
    const next = new Set(enabledIds)
    if (next.has(id)) {
      next.delete(id)
    } else {
      next.add(id)
    }
    setEnabledIds(next)
  }

  // 按分类分组
  const groupedProducts = allProducts.reduce((acc, p) => {
    const cat = p.category || '其他'
    if (!acc[cat]) acc[cat] = []
    acc[cat].push(p)
    return acc
  }, {})

  // 生成推广太阳码
  const generateShareQR = async (product) => {
    setShareModal({ open: true, product, loading: true, image: '' })
    try {
      const token = getToken()
      const partnerId = getPartnerId()
      const res = await fetch(API + '/mini/wxacode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ productId: product.id, partnerId: partnerId, width: 280 })
      })
      const data = await res.json()
      if (data.success && data.data && data.data.image) {
        setShareModal(q => ({ ...q, loading: false, image: data.data.image }))
      } else {
        alert('生成失败: ' + (data.error || '未知错误'))
        setShareModal(q => ({ ...q, loading: false }))
      }
    } catch (err) {
      alert('生成失败: ' + err.message)
      setShareModal(q => ({ ...q, loading: false }))
    }
  }

  // 复制小程序推广路径
  const copyShareLink = (product) => {
    const partnerId = getPartnerId()
    const category = product.product_category || product.category || ''
    let path = 'pages/index/index'
    if (category === 'ai_market' || category === 'AI产品') {
      path = 'pages/ai-market/detail'
    }
    const link = path + '?productId=' + product.id + '&pid=' + partnerId
    navigator.clipboard.writeText(link).then(() => {
      setShareCopyMsg('✅ 已复制！小程序路径: ' + link)
      setTimeout(() => setShareCopyMsg(''), 3000)
    }).catch(() => {
      setShareCopyMsg('小程序路径: ' + link)
    })
  }

  const renderMiniappConfig = () => (
    <div style={{ maxWidth: 800 }}>
      <h2 style={{ fontSize: 20, marginBottom: 16 }}>📦 商品上架管理</h2>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>
        勾选该机构小程序可售的商品，保存后立即生效。
      </p>
      {prodLoading ? (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          <p style={{ color: '#999', fontSize: 13, margin: 0 }}>加载中...</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          {Object.keys(groupedProducts).length === 0 ? (
            <p style={{ color: '#999', fontSize: 14, textAlign: 'center', padding: 20 }}>暂无上架商品</p>
          ) : (
            Object.keys(groupedProducts).map(cat => (
              <div key={cat} style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#666', marginBottom: 8, paddingLeft: 4 }}>{cat}</div>
                {groupedProducts[cat].map(p => (
                  <label key={p.id} style={{
                    display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer',
                    padding: '12px 16px', borderRadius: 8, marginBottom: 4,
                    background: enabledIds.has(p.id) ? '#f0f9ff' : '#fff',
                    border: '1px solid', borderColor: enabledIds.has(p.id) ? '#bae0ff' : '#f0f0f0',
                    transition: 'all 0.2s'
                  }}>
                    <input type="checkbox" checked={enabledIds.has(p.id)}
                      onChange={() => toggleProduct(p.id)}
                      style={{ width: 18, height: 18 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 500, fontSize: 15 }}>{p.name}</div>
                      {p.subtitle && <div style={{ fontSize: 12, color: '#999', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.subtitle}</div>}
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontSize: 15, fontWeight: 600, color: '#ff4d4f' }}>¥{p.base_price}</div>
                    </div>
                    <button
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); generateShareQR(p); }}
                      title="生成推广太阳码"
                      style={{ flexShrink: 0, padding: '4px 10px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, whiteSpace: 'nowrap' }}
                    >📋 推广</button>
                  </label>
                ))}
              </div>
            ))
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 16 }}>
            <button onClick={saveProductConfig} disabled={prodSaving}
              style={{ padding: '10px 32px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, opacity: prodSaving ? 0.6 : 1 }}>
              {prodSaving ? '保存中...' : '保存配置'}
            </button>
            {prodMsg && <span style={{ fontSize: 14 }}>{prodMsg}</span>}
          </div>
        </div>
      )}
    </div>
  )

  const [uploadingLogo, setUploadingLogo] = useState(false)
  const [uploadingCover, setUploadingCover] = useState(false)

  const uploadImage = async (field, file) => {
    if (!file) return
    const setLoading = field === 'logo_url' ? setUploadingLogo : setUploadingCover
    setLoading(true)
    try {
      const token = getToken()
      const formData = new FormData()
      formData.append('file', file)
      const res = await fetch(API + '/upload', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
        body: formData
      })
      const json = await res.json()
      if (json.success && json.data && json.data.url) {
        setBrandForm(prev => ({...prev, [field]: json.data.url}))
      } else {
        alert('上传失败: ' + (json.error || '未知错误'))
      }
    } catch (e) {
      alert('上传异常: ' + e.message)
    } finally {
      setLoading(false)
    }
  }

  const [brandForm, setBrandForm] = useState({
    logo_url: '',
    theme_color: '#1890ff',
    description: '',
    cover_url: '',
    phone_display: '',
    address_display: ''
  })
  const [brandLoading, setBrandLoading] = useState(true)
  const [brandSaving, setBrandSaving] = useState(false)
  const [brandMsg, setBrandMsg] = useState('')

  const loadBrandConfig = async () => {
    setBrandLoading(true)
    try {
      const token = getToken()
      const id = getPartnerId()
      const res = await fetch(API + '/institutions/' + id + '/brand', {
        headers: { 'Authorization': 'Bearer ' + token }
      })
      const json = await res.json()
      if (json.success && json.data) {
        setBrandForm({
          logo_url: json.data.logo_url || '',
          theme_color: json.data.theme_color || '#1890ff',
          description: json.data.description || '',
          cover_url: json.data.cover_url || '',
          phone_display: json.data.phone_display || '',
          address_display: json.data.address_display || ''
        })
      }
    } catch (e) {
      console.error('加载品牌配置失败', e)
    } finally {
      setBrandLoading(false)
    }
  }

  const saveBrandConfig = async () => {
    setBrandSaving(true)
    setBrandMsg('')
    try {
      const token = getToken()
      const id = getPartnerId()
      // 同时支持 PUT 和 POST（后端已有 PUT，兼容 POST）
      const res = await fetch(API + '/institutions/' + id + '/brand', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(brandForm)
      })
      const json = await res.json()
      if (json.success) {
        setBrandMsg('✅ 保存成功')
        setTimeout(() => setBrandMsg(''), 3000)
      } else {
        setBrandMsg('❌ 保存失败: ' + (json.error || '未知错误'))
      }
    } catch (e) {
      setBrandMsg('❌ 保存异常: ' + e.message)
    } finally {
      setBrandSaving(false)
    }
  }

  const [actLoading, setActLoading] = useState(true)
  const [allActivities, setAllActivities] = useState([])
  const [actEnabledIds, setActEnabledIds] = useState(new Set())

  const loadActivityShelf = async () => {
    setActLoading(true)
    try {
      const token = getToken()
      const id = getPartnerId()
      const [allRes, shelfRes] = await Promise.all([
        fetch(API + '/study-activities?status=published', { headers: { 'Authorization': '***' + token } }).then(r => r.json()),
        fetch(API + '/institutions/' + id + '/activities', { headers: { 'Authorization': '***' + token } }).then(r => r.json())
      ])
      if (allRes.success) setAllActivities(allRes.data || [])
      if (shelfRes.success) {
        setActEnabledIds(new Set((shelfRes.data || []).filter(s => s.enabled).map(s => s.activity_id)))
      }
    } catch (e) { console.error('加载活动数据失败', e)
    } finally { setActLoading(false) }
  }

  const saveActivityShelf = async () => {
    setProdSaving(true); setProdMsg('')
    try {
      const token = getToken()
      const id = getPartnerId()
      let changed = 0
      const shelfRes = await fetch(API + '/institutions/' + id + '/activities', { headers: { 'Authorization': '***' + token } }).then(r => r.json())
      const shelfList = (shelfRes.success ? shelfRes.data : []) || []
      for (const a of allActivities) {
        const isEnabled = actEnabledIds.has(a.id)
        const existing = shelfList.find(s => s.activity_id === a.id)
        if ((existing && existing.enabled !== isEnabled) || (!existing && isEnabled)) {
          await fetch(API + '/institutions/' + id + '/activities', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': '***' + token },
            body: JSON.stringify({ activity_id: a.id, enabled: isEnabled })
          })
          changed++
        }
      }
      setProdMsg(changed > 0 ? ('✅ 已更新 ' + changed + ' 项活动') : '✅ 无变更')
      setTimeout(() => setProdMsg(''), 3000)
    } catch (e) { setProdMsg('❌ 保存异常: ' + e.message)
    } finally { setProdSaving(false) }
  }

  const toggleActivity = (id) => {
    const next = new Set(actEnabledIds)
    if (next.has(id)) next.delete(id); else next.add(id)
    setActEnabledIds(next)
  }

  const groupedActivities = allActivities.reduce((acc, a) => {
    const cat = a.type || '其他'
    if (!acc[cat]) acc[cat] = []
    acc[cat].push(a)
    return acc
  }, {})

  const renderActivityShelf = () => (
    <div style={{ maxWidth: 800 }}>
      <h2 style={{ fontSize: 20, marginBottom: 16 }}>🏕️ 活动上架</h2>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>勾选总部活动上架到机构小程序，保存后立即生效。</p>
      {actLoading ? (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          <p style={{ color: '#999', fontSize: 13, margin: 0 }}>加载中...</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          {Object.keys(groupedActivities).length === 0 ? (
            <p style={{ color: '#999', fontSize: 14, textAlign: 'center', padding: 20 }}>暂无总部活动可上架</p>
          ) : (
            Object.keys(groupedActivities).map(cat => (
              <div key={cat} style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#666', marginBottom: 8, paddingLeft: 4 }}>{cat}</div>
                {groupedActivities[cat].map(a => (
                  <label key={a.id} style={{
                    display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer',
                    padding: '12px 16px', borderRadius: 8, marginBottom: 4,
                    background: actEnabledIds.has(a.id) ? '#f0f9ff' : '#fff',
                    border: '1px solid', borderColor: actEnabledIds.has(a.id) ? '#bae0ff' : '#f0f0f0'
                  }}>
                    <input type="checkbox" checked={actEnabledIds.has(a.id)}
                      onChange={() => toggleActivity(a.id)} style={{ width: 18, height: 18 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 500, fontSize: 15 }}>{a.title}</div>
                      {a.location && <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>📍 {a.location}</div>}
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: '#ff4d4f' }}>¥{a.price}</div>
                  </label>
                ))}
              </div>
            ))
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 16 }}>
            <button onClick={saveActivityShelf} disabled={prodSaving}
              style={{ padding: '10px 32px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, opacity: prodSaving ? 0.6 : 1 }}>
              {prodSaving ? '保存中...' : '保存配置'}
            </button>
            {prodMsg && <span style={{ fontSize: 14 }}>{prodMsg}</span>}
          </div>
        </div>
      )}
    </div>
  )

  // ===== 机构活动管理 =====
  const [instActivities, setInstActivities] = useState([])
  const [showInstActivityModal, setShowInstActivityModal] = useState(false)
  const [instActivityForm, setInstActivityForm] = useState({ institution_id: partnerId, title: '', type: 'activity', activity_date: '', location: '', price: 0, max_participants: 50, age_range: '', cover_image: '', description: '', highlights: '', status: 'published' })
  const [editingInstActivity, setEditingInstActivity] = useState(null)

  const loadInstitutionActivities = async () => {
    try {
      const res = await apiGet(`/cms/api/institution-activities/admin/list?institution_id=${partnerId}`)
      if (res.success) setInstActivities(res.data || [])
    } catch (e) { console.error('加载机构活动失败', e) }
  }

  const handleSaveInstActivity = async () => {
    if (!instActivityForm.title) { alert('请填写活动名称'); return }
    try {
      const res = editingInstActivity
        ? await apiPut(`/cms/api/institution-activities/admin/${editingInstActivity.id}`, instActivityForm)
        : await apiPost(`/cms/api/institution-activities/admin`, instActivityForm)
      if (res.success) {
        alert(editingInstActivity ? '更新成功!' : '创建成功!')
        setShowInstActivityModal(false)
        setEditingInstActivity(null)
        setInstActivityForm({ institution_id: partnerId, title: '', type: 'activity', activity_date: '', location: '', price: 0, max_participants: 50, age_range: '', cover_image: '', description: '', highlights: '', status: 'published' })
        loadInstitutionActivities()
      } else { alert(res.error || '操作失败') }
    } catch (e) { alert('操作失败') }
  }

  const openEditInstActivity = (a) => {
    setEditingInstActivity(a)
    setInstActivityForm({ institution_id: a.institution_id || partnerId, title: a.title || '', type: a.type || 'activity', activity_date: a.activity_date || '', location: a.location || '', price: a.price || 0, max_participants: a.max_participants || 50, age_range: a.age_range || '', cover_image: a.cover_image || '', description: a.description || '', highlights: a.highlights || '', status: a.status || 'published' })
    setShowInstActivityModal(true)
  }

  const handleDeleteInstActivity = async (id) => {
    if (!confirm('确定删除此活动?')) return
    try {
      const res = await apiDelete(`/cms/api/institution-activities/${id}`)
      if (res.success) { alert('已删除!'); loadInstitutionActivities() }
      else { alert(res.error || '删除失败') }
    } catch (e) { alert('删除失败') }
  }

  const renderInstitutionActivities = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>📋 机构活动管理</h2>
        <div style={{ fontSize: 13, color: '#999' }}>机构独立活动，直接发布到机构小程序，无需总部审核</div>
      </div>
      <div style={{ marginBottom: 16, background: '#f9f0ff', padding: 12, borderRadius: 8, fontSize: 13, color: '#722ed1' }}>
        💡 机构活动直接发布到您的机构小程序首页，家长可直接在小程序内查看和报名。
      </div>
      <button onClick={() => { setEditingInstActivity(null); setInstActivityForm({ institution_id: partnerId, title: '', type: 'activity', activity_date: '', location: '', price: 0, max_participants: 50, age_range: '', cover_image: '', description: '', highlights: '', status: 'published' }); setShowInstActivityModal(true) }}
        style={{ marginBottom: 16, padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>
        + 创建机构活动
      </button>
      {showInstActivityModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 500, maxHeight: '80vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 20px' }}>{editingInstActivity ? '编辑机构活动' : '创建机构活动'}</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>活动名称 *</label>
              <input value={instActivityForm.title} onChange={e => setInstActivityForm({...instActivityForm, title: e.target.value})} placeholder="请输入活动名称" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>活动日期</label>
                <input type="date" value={instActivityForm.activity_date} onChange={e => setInstActivityForm({...instActivityForm, activity_date: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>价格(元)</label>
                <input type="number" value={instActivityForm.price} onChange={e => setInstActivityForm({...instActivityForm, price: parseFloat(e.target.value) || 0})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>地点</label>
              <input value={instActivityForm.location} onChange={e => setInstActivityForm({...instActivityForm, location: e.target.value})} placeholder="请输入活动地点" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>人数上限</label>
                <input type="number" value={instActivityForm.max_participants} onChange={e => setInstActivityForm({...instActivityForm, max_participants: parseInt(e.target.value) || 50})} style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>适合年龄</label>
                <input value={instActivityForm.age_range} onChange={e => setInstActivityForm({...instActivityForm, age_range: e.target.value})} placeholder="如: 3-6岁" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>封面图URL</label>
              <input value={instActivityForm.cover_image} onChange={e => setInstActivityForm({...instActivityForm, cover_image: e.target.value})} placeholder="请输入封面图片链接" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>活动简介</label>
              <textarea value={instActivityForm.description} onChange={e => setInstActivityForm({...instActivityForm, description: e.target.value})} placeholder="请输入活动简介" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6, minHeight: 80, resize: 'vertical' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>活动亮点</label>
              <textarea value={instActivityForm.highlights} onChange={e => setInstActivityForm({...instActivityForm, highlights: e.target.value})} placeholder="请输入活动亮点" style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6, minHeight: 60, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
              <button onClick={() => { setShowInstActivityModal(false); setEditingInstActivity(null) }} style={{ padding: '10px 20px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleSaveInstActivity} style={{ padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>{editingInstActivity ? '保存修改' : '立即发布'}</button>
            </div>
          </div>
        </div>
      )}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        {instActivities.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 60 }}><div style={{ fontSize: 48, marginBottom: 16 }}>📋</div><p>暂无机构活动，点击上方按钮创建</p></div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>活动名称</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>日期</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>地点</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>价格</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>报名</th>
                <th style={{ padding: '12px 8px', textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {instActivities.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 500 }}>{a.title}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{a.activity_date}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{a.location || '-'}</td>
                  <td style={{ padding: '12px 8px', color: '#52c41a' }}>{a.price > 0 ? `¥${a.price}` : '免费'}</td>
                  <td style={{ padding: '12px 8px' }}>{a.current_participants || 0}/{a.max_participants}</td>
                  <td style={{ padding: '12px 8px' }}>
                    <button onClick={() => openEditInstActivity(a)} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}>编辑</button>
                    <button onClick={() => handleDeleteInstActivity(a.id)} style={{ padding: '4px 12px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // ===== 结算管理 =====
  const [settlementData, setSettlementData] = useState([])
  const [settlementLoading, setSettlementLoading] = useState(false)
  const [selectedInstPeriod, setSelectedInstPeriod] = useState('')
  const [settlementOrders, setSettlementOrders] = useState([])

  const loadSettlementData = async () => {
    setSettlementLoading(true)
    try {
      const instId = selectedInstitution
      if (!instId) {
        setSettlementData([])
        setSettlementLoading(false)
        return
      }
      const res = await fetch(`/cms/api/institution-orders/summary?institution_id=${instId}`)
      const json = await res.json()
      if (json.success) {
        setSettlementData(json.data || [])
      }
    } catch (e) {
      console.error('加载结算数据失败', e)
    }
    setSettlementLoading(false)
  }

  const loadSettlementOrders = async (period) => {
    try {
      const instId = selectedInstitution
      if (!instId || !period) return
      const res = await fetch(`/cms/api/institution-orders?institution_id=${instId}&status=paid`)
      const json = await res.json()
      if (json.success) {
        setSettlementOrders(json.data || [])
      }
    } catch (e) {
      console.error('加载结算订单失败', e)
    }
  }

  const renderSettlement = () => (
    <div style={{ maxWidth: 1000 }}>
      <h2 style={{ fontSize: 20, marginBottom: 16 }}>💳 结算管理</h2>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>
        按月度汇总机构销售结算数据，包含机构分成与推广佣金。
      </p>

      {/* 结算汇总表 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: 16 }}>📊 月度结算汇总</h3>
        {settlementLoading ? (
          <p style={{ color: '#999', fontSize: 13 }}>加载中...</p>
        ) : settlementData.length === 0 ? (
          <p style={{ color: '#999', fontSize: 13 }}>暂无结算数据</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>结算周期</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>总销售额</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>机构分成</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>推广佣金</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>平台留成</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>应付机构</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>状态</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {settlementData.map(row => {
                const commissionAmount = parseFloat(row.total_commission) || 0
                const agentAmount = parseFloat(row.total_agent_fee) || 0
                const platformFee = parseFloat(row.total_sales) - commissionAmount
                const netPayable = commissionAmount - agentAmount
                return (
                  <tr key={row.id || row.period} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>{row.period}</td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{parseFloat(row.total_sales).toFixed(2)}</td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{commissionAmount.toFixed(2)}</td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{agentAmount.toFixed(2)}</td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{Math.max(0, platformFee).toFixed(2)}</td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}><strong>¥{Math.max(0, netPayable).toFixed(2)}</strong></td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>
                      <span style={{
                        padding: '2px 8px', borderRadius: 4, fontSize: 12,
                        background: row.status === 'paid' ? '#f6ffed' : '#fffbe6',
                        color: row.status === 'paid' ? '#52c41a' : '#faad14'
                      }}>
                        {row.status === 'paid' ? '已结算' : '待结算'}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>
                      <button
                        onClick={() => {
                          setSelectedInstPeriod(row.period)
                          loadSettlementOrders(row.period)
                        }}
                        style={{ fontSize: 12, padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                      >
                        查看订单
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* 结算期订单明细 */}
      {selectedInstPeriod && settlementOrders.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: 16 }}>📄 {selectedInstPeriod} 订单明细</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>订单号</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>商品</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>金额</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>家长</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>机构分成</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>推广佣金</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }}>支付时间</th>
              </tr>
            </thead>
            <tbody>
              {settlementOrders.map(o => (
                <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '10px 12px', fontFamily: 'monospace', fontSize: 11 }}>{o.order_no}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>{o.product_name}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{parseFloat(o.price).toFixed(2)}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>{o.parent_name}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>¥{parseFloat(o.commission_amount || 0).toFixed(2)}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>{o.agent_amount > 0 ? '¥' + parseFloat(o.agent_amount).toFixed(2) : '-'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }}>{o.paid_at ? o.paid_at.slice(0, 16) : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 结算规则说明 */}
      <div style={{ background: '#f0f5ff', borderRadius: 12, padding: 16 }}>
        <h4 style={{ margin: '0 0 8px 0', fontSize: 14 }}>📌 结算规则</h4>
        <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#666', lineHeight: 2 }}>
          <li>结算周期：自然月结算</li>
          <li>机构分成 = 商品售价 × 机构分成比例（默认50%）</li>
          <li>推广佣金 = 商品售价 × 推广员佣金率（由推广员等级决定）</li>
          <li>应付机构 = 机构分成 - 推广佣金</li>
          <li>平台留成 = 商品售价 - 机构分成（平台承担推广佣金支出）</li>
          <li>结算状态由平台管理员手动更新为</li>
        </ul>
      </div>
    </div>
  )


  // ===== 业务员管理 =====
  const [salespersons, setSalespersons] = useState([])
  const [salespersonsLoading, setSalespersonsLoading] = useState(false)
  const [showSalesAdd, setShowSalesAdd] = useState(false)
  const [newSalesName, setNewSalesName] = useState('')
  const [newSalesPhone, setNewSalesPhone] = useState('')
  const [newSalesRate, setNewSalesRate] = useState(5)

  const loadSalespersons = async () => {
    const instId = selectedInstitution
    if (!instId) { setSalespersons([]); return }
    setSalespersonsLoading(true)
    try {
      const res = await fetch('/cms/api/institution-salespersons?institution_id=' + instId)
      const json = await res.json()
      if (json.success) setSalespersons(json.data || [])
    } catch (e) { console.error('加载业务员失败', e) }
    setSalespersonsLoading(false)
  }

  const addSalesperson = async () => {
    const instId = selectedInstitution
    if (!instId || !newSalesName || !newSalesPhone) return
    try {
      const res = await fetch('/cms/api/institution-salespersons', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ institution_id: instId, name: newSalesName, phone: newSalesPhone, commission_rate: newSalesRate })
      })
      const json = await res.json()
      if (json.success) {
        setShowSalesAdd(false)
        setNewSalesName(''); setNewSalesPhone(''); setNewSalesRate(5)
        loadSalespersons()
      } else { alert(json.error) }
    } catch (e) { alert('添加失败') }
  }

  const deleteSalesperson = async (id) => {
    if (!confirm('确定删除该业务员？')) return
    try {
      const res = await fetch('/cms/api/institution-salespersons/' + id, { method: 'DELETE' })
      const json = await res.json()
      if (json.success) loadSalespersons()
    } catch (e) { alert('删除失败') }
  }

  const updateSalesRate = async (id, val) => {
    try {
      await fetch('/cms/api/institution-salespersons/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ commission_rate: parseInt(val) || 0 })
      })
    } catch (e) { console.error('更新失败', e) }
  }

  const renderSalespersons = () => (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>👤 业务员管理</h2>
        <button onClick={() => setShowSalesAdd(true)}
          style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
          + 添加业务员
        </button>
      </div>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>
        管理机构的推广业务员（雇佣关系），业务员可帮机构推广商品赚取提成。
      </p>

      {showSalesAdd && (
        <div style={{ background: '#fafafa', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: 15 }}>添加业务员</h3>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <input value={newSalesName} onChange={e => setNewSalesName(e.target.value)}
              placeholder="姓名" style={inputStyle} />
            <input value={newSalesPhone} onChange={e => setNewSalesPhone(e.target.value)}
              placeholder="手机号" style={inputStyle} />
            <div>
              <label style={{ fontSize: 12, color: '#666', marginRight: 6 }}>提成(%)</label>
              <input type="number" min="0" max="100" value={newSalesRate}
                onChange={e => setNewSalesRate(parseInt(e.target.value) || 0)}
                style={{ width: 60, padding: '8px 8px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13 }} />
            </div>
            <button onClick={addSalesperson}
              style={{ padding: '8px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
              确认添加
            </button>
            <button onClick={() => setShowSalesAdd(false)}
              style={{ padding: '8px 20px', background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer' }}>
              取消
            </button>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>姓名</th>
              <th style={th}>手机号</th>
              <th style={th}>提成比例</th>
              <th style={th}>累计业绩</th>
              <th style={th}>状态</th>
              <th style={th}>创建时间</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {salespersonsLoading ? <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</td></tr>
            : salespersons.length === 0 ? <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无业务员，点击上方按钮添加</td></tr>
            : salespersons.map(s => (
              <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{s.name}</td>
                <td style={td}>{s.phone}</td>
                <td style={td}>
                  <input type="number" min="0" max="100" defaultValue={s.commission_rate}
                    style={{ width: 60, padding: '4px 6px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13 }}
                    onBlur={e => updateSalesRate(s.id, e.target.value)} />%
                </td>
                <td style={td}>¥{parseFloat(s.total_sales || 0).toFixed(0)}</td>
                <td style={td}>
                  <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12,
                    background: s.status === 'active' ? '#f6ffed' : '#fff2f0',
                    color: s.status === 'active' ? '#52c41a' : '#ff4d4f' }}>
                    {s.status === 'active' ? '正常' : '停用'}
                  </span>
                </td>
                <td style={td}>{s.created_at ? s.created_at.slice(0, 10) : '-'}</td>
                <td style={td}>
                  <button onClick={() => deleteSalesperson(s.id)}
                    style={{ padding: '3px 10px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>
                    删除
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ background: '#f0f5ff', borderRadius: 12, padding: 16, marginTop: 20 }}>
        <h4 style={{ margin: '0 0 8px 0', fontSize: 14 }}>📌 业务员说明</h4>
        <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#666', lineHeight: 2 }}>
          <li>业务员是机构的雇佣销售，与推广员（家长分享分销）不同</li>
          <li>业务员提成从机构分成中扣除，机构实得 = 机构分成 - 业务员提成</li>
          <li>提成比例可随时调整，新订单按最新比例计算</li>
          <li>删除业务员不会影响已有订单的提成记录</li>
        </ul>
      </div>
    </div>
  )

  const th = { padding: '10px 12px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8' }
  const td = { padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }
  const inputStyle = { padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13, width: 160 }


  const renderBrandConfig = () => (
    <div style={{ maxWidth: 800 }}>
      <h2 style={{ fontSize: 20, marginBottom: 16 }}>🎨 品牌配置</h2>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>
        配置机构品牌信息，修改后保存即生效。Logo 和封面图建议使用 CDN 链接。
      </p>
      {brandLoading ? (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          <p style={{ color: '#999', fontSize: 13, margin: 0 }}>加载中...</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
          <div style={{ display: 'grid', gap: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>Logo</label>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{ width: 80, height: 80, borderRadius: 8, border: '1px solid #d9d9d9', overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
                  {brandForm.logo_url ? <img src={brandForm.logo_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ color: '#ccc', fontSize: 12 }}>无</span>}
                </div>
                <div style={{ flex: 1 }}>
                  <input type="file" accept="image/*" id="logoUpload" style={{ display: 'none' }}
                    onChange={e => { if (e.target.files.length) uploadImage('logo_url', e.target.files[0]); e.target.value = '' }} />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <label htmlFor="logoUpload" style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 13, display: 'inline-block' }}>
                      {uploadingLogo ? '上传中...' : '选择图片'}
                    </label>
                    <input value={brandForm.logo_url} onChange={e => setBrandForm({...brandForm, logo_url: e.target.value})}
                      placeholder="或直接粘贴图片链接"
                      style={{ flex: 1, padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }} />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>主题色</label>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <input type="color" value={brandForm.theme_color}
                  onChange={e => setBrandForm({...brandForm, theme_color: e.target.value})}
                  style={{ width: 44, height: 44, border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', padding: 2 }} />
                <input value={brandForm.theme_color} onChange={e => setBrandForm({...brandForm, theme_color: e.target.value})}
                  placeholder="#1890ff"
                  style={{ flex: 1, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>简介</label>
              <textarea value={brandForm.description} onChange={e => setBrandForm({...brandForm, description: e.target.value})}
                placeholder="机构简介..."
                rows={3} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, resize: 'vertical' }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>封面图</label>
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 160, height: 90, borderRadius: 8, border: '1px solid #d9d9d9', overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
                  {brandForm.cover_url ? <img src={brandForm.cover_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ color: '#ccc', fontSize: 12 }}>无</span>}
                </div>
                <div style={{ flex: 1 }}>
                  <input type="file" accept="image/*" id="coverUpload" style={{ display: 'none' }}
                    onChange={e => { if (e.target.files.length) uploadImage('cover_url', e.target.files[0]); e.target.value = '' }} />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <label htmlFor="coverUpload" style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 13, display: 'inline-block' }}>
                      {uploadingCover ? '上传中...' : '选择图片'}
                    </label>
                    <input value={brandForm.cover_url} onChange={e => setBrandForm({...brandForm, cover_url: e.target.value})}
                      placeholder="或直接粘贴图片链接"
                      style={{ flex: 1, padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }} />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>联系电话（展示用）</label>
              <input value={brandForm.phone_display} onChange={e => setBrandForm({...brandForm, phone_display: e.target.value})}
                placeholder="138xxxxxxx"
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 }}>地址（展示用）</label>
              <input value={brandForm.address_display} onChange={e => setBrandForm({...brandForm, address_display: e.target.value})}
                placeholder="XX市XX区XX路XX号"
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 20 }}>
            <button onClick={saveBrandConfig} disabled={brandSaving}
              style={{ padding: '10px 32px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, opacity: brandSaving ? 0.6 : 1 }}>
              {brandSaving ? '保存中...' : '保存'}
            </button>
            {brandMsg && <span style={{ fontSize: 14 }}>{brandMsg}</span>}
          </div>
        </div>
      )}
    </div>
  )

  const renderCourseQuota = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>📚 课程配额管理</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={() => { setBuyCourseForm({ productName: '', productId: '', quantity: 1 }); setShowBuyCourseModal(true) }}
            style={{ padding: '10px 20px', background: '#13c2c2', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            + 采购课程配额
          </button>
          <button
            onClick={() => { setAssignCourseForm({ productId: '', childName: '', childPhone: '' }); setShowAssignCourseModal(true) }}
            style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            + 分配课程
          </button>
        </div>
      </div>

      {/* 采购弹窗 */}
      {showBuyCourseModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 450 }}>
            <h3 style={{ margin: '0 0 20px' }}>采购课程配额</h3>
            <p style={{ color: '#999', fontSize: 13, marginBottom: 16 }}>机构采购价请查看各课程详情（七彩故事工坊¥149/人含线上权限）</p>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>选择课程 *</label>
              <select
                value={buyCourseForm.productName}
                onChange={e => {
                  const val = e.target.value
                  const [name, id] = val.split('|')
                  setBuyCourseForm({ ...buyCourseForm, productName: name, productId: id })
                }}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              >
                <option value="">-- 请选择课程 --</option>
                {COURSE_PRODUCTS.map(cp => (
                  <option key={cp.id} value={`${cp.name}|${cp.id}`}>{cp.icon} {cp.name}（¥{cp.unitPrice}/孩子）</option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>配额数量（学员人数） *</label>
              <input type="number" min="1" value={buyCourseForm.quantity}
                onChange={e => setBuyCourseForm({ ...buyCourseForm, quantity: parseInt(e.target.value) || 1 })}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowBuyCourseModal(false)}
                style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleBuyCourseQuota}
                style={{ padding: '10px 20px', background: '#13c2c2', color: '#fff', border: 'none', borderRadius: 6 }}>确认采购</button>
            </div>
          </div>
        </div>
      )}

      {/* 分配弹窗 */}
      {showAssignCourseModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 450 }}>
            <h3 style={{ margin: '0 0 20px' }}>分配课程给学员</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>选择课程 *</label>
              <select
                value={assignCourseForm.productId}
                onChange={e => setAssignCourseForm({ ...assignCourseForm, productId: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              >
                <option value="">-- 请选择课程 --</option>
                {courseQuotas.filter(q => q.remainingQuota > 0).length === 0 ? (
                  <option value="" disabled>暂无可分配的课程，请先在左侧采购</option>
                ) : (
                  courseQuotas.filter(q => q.remainingQuota > 0).map(q => (
                    <option key={q.id} value={q.productId}>{q.productName}（剩余{q.remainingQuota}个）</option>
                  ))
                )}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>孩子姓名</label>
              <input value={assignCourseForm.childName}
                onChange={e => setAssignCourseForm({ ...assignCourseForm, childName: e.target.value })}
                placeholder="如：洪昕"
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>孩子ID或手机号 *</label>
              <input value={assignCourseForm.childPhone}
                onChange={e => setAssignCourseForm({ ...assignCourseForm, childPhone: e.target.value })}
                placeholder="输入 childId 或手机号"
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowAssignCourseModal(false)}
                style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}>取消</button>
              <button onClick={handleAssignCourse}
                style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6 }}>确认分配</button>
            </div>
          </div>
        </div>
      )}

      {/* 课程配额余额 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>📦 已购课程配额</h3>
        {courseQuotas.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📚</div>
            <p>暂无已购课程配额，点击上方按钮采购</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
            {courseQuotas.map(q => (
              <div key={q.id} style={{ padding: 16, borderRadius: 8, background: '#f6ffed', border: '1px solid #b7eb8f' }}>
                <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 8 }}>{q.productName}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#666' }}>
                  <span>总计: <b>{q.totalQuota}</b> 个</span>
                  <span>已分配: <b>{q.usedQuota}</b> 个</span>
                  <span>剩余: <b style={{ color: q.remainingQuota > 0 ? '#52c41a' : '#ff4d4f' }}>{q.remainingQuota}</b> 个</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 分配记录 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>📋 分配记录</h3>
        {courseAssignments.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>暂无分配记录</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>课程</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>孩子</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>手机/ID</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>时间</th>
              </tr>
            </thead>
            <tbody>
              {courseAssignments.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px' }}>{a.product_name}</td>
                  <td style={{ padding: '12px 8px' }}>{a.child_name || '-'}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{a.child_id || a.phone || '-'}</td>
                  <td style={{ padding: '12px 8px', color: '#999', fontSize: 13 }}>{a.assigned_at?.slice(0, 16)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 渲染动画配额
  const renderCredits = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <h2>🎬 动画配额管理</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={() => setShowBuyCreditModal(true)}
            style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            + 采购动画次包
          </button>
          <button
            onClick={() => setShowAssignModal(true)}
            style={{ padding: '10px 20px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            📤 分配次数
          </button>
        </div>
      </div>

      {/* 余额卡片 */}
      {creditBalance && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
          <StatCard icon="🎬" label="总采购次数" value={creditBalance.totalCredits} color="#1890ff" />
          <StatCard icon="✅" label="已分配次数" value={creditBalance.usedCredits} color="#fa8c16" />
          <StatCard icon="💎" label="剩余次数" value={creditBalance.remainingCredits} color="#52c41a" />
        </div>
      )}

      {/* 采购弹窗 */}
      {showBuyCreditModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 440 }}>
            <h3 style={{ margin: '0 0 20px' }}>采购动画次包</h3>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>产品</label>
              <select
                value={buyForm.productName}
                onChange={e => setBuyForm({ ...buyForm, productName: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              >
                <option value="AI动画10次包">AI动画10次包（¥49.5）</option>
                <option value="AI动画30次包">AI动画30次包（¥129.5）</option>
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>数量</label>
              <input
                type="number"
                min="1"
                value={buyForm.quantity}
                onChange={e => setBuyForm({ ...buyForm, quantity: parseInt(e.target.value) || 1 })}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
              <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                采购价：机构成本价 50%
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowBuyCreditModal(false)}
                style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}
              >
                取消
              </button>
              <button
                onClick={async () => {
                  if (!buyForm.productName || buyForm.quantity < 1) { alert('请选择产品和数量'); return }
                  try {
                    const res = await apiPost('/courses/quota/buy-credits', {
                      institutionId: getPartnerId(),
                      productName: buyForm.productName,
                      quantity: buyForm.quantity
                    })
                    if (res.success) {
                      alert(`采购成功！获得 ${res.data.creditsAdded} 次，花费 ¥${res.data.totalCost}`)
                      setShowBuyCreditModal(false)
                      loadCreditData()
                    } else {
                      alert(res.error || '采购失败')
                    }
                  } catch (e) {
                    alert('采购失败: ' + e.message)
                  }
                }}
                style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6 }}
              >
                确认采购
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 分配弹窗 */}
      {showAssignModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 440 }}>
            <h3 style={{ margin: '0 0 20px' }}>分配动画次数</h3>
            <div style={{ marginBottom: 12, background: '#fff7e6', padding: '10px 16px', borderRadius: 6, fontSize: 13 }}>
              💡 剩余次数：<strong>{creditBalance?.remainingCredits || 0}</strong> 次
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>家长手机号 *</label>
              <input
                value={assignForm.phone}
                onChange={e => setAssignForm({ ...assignForm, phone: e.target.value })}
                placeholder="输入家长手机号"
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>孩子姓名（选填）</label>
              <input
                value={assignForm.childName}
                onChange={e => setAssignForm({ ...assignForm, childName: e.target.value })}
                placeholder="输入孩子姓名"
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4 }}>分配次数 *</label>
              <input
                type="number"
                min="1"
                max={creditBalance?.remainingCredits || 1}
                value={assignForm.credits}
                onChange={e => setAssignForm({ ...assignForm, credits: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowAssignModal(false)}
                style={{ padding: '10px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}
              >
                取消
              </button>
              <button
                onClick={async () => {
                  if (!assignForm.phone || !assignForm.credits || parseInt(assignForm.credits) < 1) {
                    alert('请填写手机号和分配次数'); return
                  }
                  if (parseInt(assignForm.credits) > (creditBalance?.remainingCredits || 0)) {
                    alert('分配次数超过剩余额度'); return
                  }
                  try {
                    const res = await apiPost('/courses/quota/assign-credits', {
                      institutionId: getPartnerId(),
                      phone: assignForm.phone,
                      childName: assignForm.childName,
                      credits: parseInt(assignForm.credits)
                    })
                    if (res.success) {
                      alert(`分配成功！${res.data.assigned} 次已到家长账户`)
                      setShowAssignModal(false)
                      loadCreditData()
                    } else {
                      alert(res.error || '分配失败')
                    }
                  } catch (e) {
                    alert('分配失败: ' + e.message)
                  }
                }}
                style={{ padding: '10px 20px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 6 }}
              >
                确认分配
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 分配记录列表 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
        <h3 style={{ marginBottom: 16 }}>📋 分配记录</h3>
        {creditAssignments.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>暂无分配记录</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>手机号</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>孩子</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>次数</th>
                <th style={{ padding: '12px 8px', textAlign: 'left', color: '#666' }}>时间</th>
              </tr>
            </thead>
            <tbody>
              {creditAssignments.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px' }}>{a.phone}</td>
                  <td style={{ padding: '12px 8px' }}>{a.child_name || '-'}</td>
                  <td style={{ padding: '12px 8px', color: '#1890ff', fontWeight: 500 }}>+{a.credits}</td>
                  <td style={{ padding: '12px 8px', color: '#999', fontSize: 13 }}>{a.assigned_at?.slice(0, 16)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )

  // 统计卡片组件
  const StatCard = ({ icon, label, value, color }) => (
    <div style={{ background: '#fff', borderRadius: 12, padding: 20, display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={{ width: 48, height: 48, borderRadius: 12, background: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 24, fontWeight: 600, color: '#333' }}>{value}</div>
        <div style={{ fontSize: 13, color: '#999' }}>{label}</div>
      </div>
    </div>
  )

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f5f5' }}>

      {/* 推广太阳码弹窗 */}
      {shareModal.open && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 32, width: 400, textAlign: 'center' }}>
            <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>📱 推广{shareModal.product?.name || '商品'}</h3>
            <p style={{ color: '#999', fontSize: 13, margin: '0 0 20px' }}>用户扫码即绑定您的推广关系</p>
            {shareModal.loading ? (
              <div style={{ padding: 40, color: '#999' }}>生成中...</div>
            ) : shareModal.image ? (
              <>
                <img src={shareModal.image} alt="小程序码" style={{ width: 220, height: 220, display: 'block', margin: '0 auto 16px', borderRadius: 8, border: '1px solid #f0f0f0' }} />
                {shareCopyMsg && (
                  <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: '8px 12px', marginBottom: 12, fontSize: 12, color: '#52c41a', wordBreak: 'break-all' }}>{shareCopyMsg}</div>
                )}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                  <button onClick={() => copyShareLink(shareModal.product)} style={{ padding: '8px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>📋 复制小程序路径</button>
                  <button onClick={() => setShareModal({ open: false, product: null, loading: false, image: '' })} style={{ padding: '8px 20px', background: '#f5f5f5', color: '#666', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>关闭</button>
                </div>
              </>
            ) : (
              <div style={{ padding: 40, color: '#ff4d4f' }}>生成失败</div>
            )}
          </div>
        </div>
      )}

      {/* 侧边栏 */}
      <div style={{ width: 200, background: '#fff', borderRight: '1px solid #f0f0f0', padding: '20px 0', position: 'fixed', height: '100vh', overflowY: 'auto' }}>
        <div style={{ padding: '0 16px 20px', borderBottom: '1px solid #f0f0f0', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>🏪 合作伙伴</h3>
          <p style={{ margin: '4px 0 0', fontSize: 12, color: '#999' }}>{partnerType === 'base' ? '基地' : '机构'}</p>
        </div>

        {tabs.map(tab => (
          <div
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '12px 16px',
              cursor: 'pointer',
              background: activeTab === tab.key ? '#e6f7ff' : 'transparent',
              color: activeTab === tab.key ? '#1890ff' : '#333',
              borderLeft: activeTab === tab.key ? '3px solid #1890ff' : '3px solid transparent'
            }}
          >
            <span style={{ marginRight: 8 }}>{tab.icon}</span>
            {tab.label}
          </div>
        ))}

        <div style={{ position: 'absolute', bottom: 20, width: 200, padding: '0 16px' }}>
          <button onClick={handleLogout} style={{ width: '100%', padding: '10px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', color: '#666' }}>
            退出登录
          </button>
        </div>
      </div>

      {/* 主内容区 */}
      <div style={{ flex: 1, padding: 24, marginLeft: 200, overflowY: 'auto' }}>
        {activeTab === 'dashboard' && renderDashboard()}
        {activeTab === 'activities' && renderActivities()}
        {activeTab === 'appointments' && renderAppointments()}
        {activeTab === 'orders' && renderOrders()}
        {activeTab === 'members' && renderMembers()}
        {activeTab === 'verification' && renderVerification()}
        {activeTab === 'credits' && renderCredits()}
        {activeTab === 'courseQuota' && renderCourseQuota()}
        {activeTab === 'brand' && renderBrandConfig()}
        {activeTab === 'miniapp' && renderMiniappConfig()}
        {activeTab === 'activity_shelf' && renderActivityShelf()}
        {activeTab === 'inst_activities' && renderInstitutionActivities()}
        {activeTab === 'settlement' && renderSettlement()}
        {activeTab === 'salespersons' && renderSalespersons()}
      </div>
    </div>
  )
}
